let SubjectUtil = {};

SubjectUtil.merge = function (subjects, compStats, recStats, faultStats, messages, analyticsEnabled) {
  return subjects.map(function (subject) {
    let id = subject.id;
    let compStat = compStats[id] || {};
    let recStat = recStats[id] || {};
    let faultStat = faultStats[id] || {};

    let sub = { ...subject };

    sub.compliancePct = (compStat.tasksCompleted / compStat.tasksAssigned) || NaN;
    sub.firstStartTs = recStat.firstStartTs || NaN;
    sub.lastStartTs = recStat.lastStartTs || NaN;
    sub.durationMs = recStat.durationMs || 0;
    sub.countRecordings = recStat.countRecordings || 0;
    sub.countDays = recStat.countDays || 0;
    sub.faultCount = faultStat.countFaults || 0;
    sub.messageCount = messages.filter((msg) => msg.subjectId === id).length;
    sub.hasAnalytics = recStat.lastStartTs && analyticsEnabled;

    return sub;
  });
};

module.exports = SubjectUtil;
